import { useDownloadContractMutation } from 'redux/Api/contractsApi/contractsApi';

export const useDownloadContract = ({
  contractId,
  contractNumber,
  setIsLoadingDownloading,
}: {
  contractId: number | null;
  contractNumber: string | null;
  setIsLoadingDownloading: (isLoading: boolean) => void;
}) => {
  const [downloadContract] = useDownloadContractMutation();

  const handleDownloadContract = async () => {
    try {
      if (!contractId || !contractNumber) {
        return;
      }

      const blob = await downloadContract(contractId).unwrap();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `unified_contract_${contractNumber}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('error', error);
    } finally {
      setIsLoadingDownloading(false);
    }
  };

  return { handleDownloadContract };
};
